import { PropsWithChildren } from 'react'

type MainProps = {}

export const Main = ({ children }: PropsWithChildren<MainProps>) => {
  return <div className="flex flex-nowrap">{children}</div>
}
